import RouteErrorBoundary from "./RouteErrorBoundary";

export default RouteErrorBoundary;
